import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { cmsAPI } from "../../services/api";
import { getImageUrl } from "../../utils/image";

export function Seo({ page, defaultTitle = "Sava Fresh Trading FZE", defaultDesc = "Premium global food trading company.", defaultKeywords = "food trading, global sourcing, export", fallbackObj = null }) {
  const [seo, setSeo] = useState({ title: "", description: "", keywords: "", canonical: "", ogImage: "" });

  useEffect(() => {
    if (fallbackObj) {
      setSeo({
        title: fallbackObj.metaTitle || fallbackObj.name || fallbackObj.title || defaultTitle,
        description: fallbackObj.metaDesc || fallbackObj.shortDesc || fallbackObj.excerpt || defaultDesc,
        keywords: fallbackObj.focusKeyword || fallbackObj.metaKeywords || defaultKeywords,
        canonical: fallbackObj.canonical || "",
        ogImage: fallbackObj.imageUrl || fallbackObj.ogImage || "",
      });
      return;
    }

    if (!page) return;

    cmsAPI.getPage(page)
      .then(r => {
        const content = r.data.content || {};
        const seoData = content.seo || {};
        setSeo({
          title: seoData.title?.value || defaultTitle,
          description: seoData.description?.value || defaultDesc,
          keywords: seoData.keywords?.value || defaultKeywords,
          canonical: seoData.canonical?.value || "",
          ogImage: seoData.ogImage?.value || "",
        });
      })
      .catch(() => {
        setSeo({ title: defaultTitle, description: defaultDesc, keywords: defaultKeywords, canonical: "", ogImage: "" });
      });
  }, [page, fallbackObj, defaultTitle, defaultDesc, defaultKeywords]);

  const ogImageUrl = seo.ogImage ? (seo.ogImage.startsWith("http") ? seo.ogImage : window.location.origin + getImageUrl(seo.ogImage)) : null;

  return (
    <Helmet>
      {seo.title && <title>{seo.title}</title>}
      {seo.description && <meta name="description" content={seo.description} />}
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
      {seo.canonical && <link rel="canonical" href={seo.canonical} />}
      
      {/* OpenGraph */}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.description && <meta property="og:description" content={seo.description} />}
      {ogImageUrl && <meta property="og:image" content={ogImageUrl} />}
      
      {/* Twitter */}
      <meta name="twitter:card" content={ogImageUrl ? "summary_large_image" : "summary"} />
      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {seo.description && <meta name="twitter:description" content={seo.description} />}
      {ogImageUrl && <meta name="twitter:image" content={ogImageUrl} />}
    </Helmet>
  );
}

export default Seo;
